import Svgs from 'data/Svgs';
import Constants from 'data/Constants';
import Connection from 'data/Connection';
import CmpMgr from 'util/ComponentManager';
import Element from 'util/Element';
import Utils from 'util/Utils';
import LiveCard from 'widgets/card/Card';

//////////////////////////////////////
import GraphQL from './../../codewell/init-graphql';
//////////

//////////////////////////////////////////////
import LiveFilemanagerWindow from './../../filemanager/window/Window';
//////////

/////////////////////////////////////////
import LiveSurveyPreviewWindow from './../../survey/preview/Preview';
//////////

/////////////////////////////////////////////
import LiveFilemanagerRds from './../../filemanager/auth/Rds/Rds';
//////////

////////////////////////////////////////////////
import LiveFilemanagermToken from './../../filemanager/auth/mToken/mToken';
//////////

/**
 * LIVE Chat Window Component (not available in Asseco namespace)
 *
 * @private
 */
class LiveChatWindowFS extends LiveCard {
    /**
     * Holds configuration if file upload in chat window is enabled
     *
     * @type {Boolean} fileUpload
     */
    fileUpload;

    /**
     * Specify file upload icon in chat window if enabled
     *
     * @type {String} fileUploadIcon
     */
    fileUploadIcon;

    /**
     * Holds configuration if transcript download in chat window is enabled
     *
     * @type {Boolean} tranDownload
     */
    tranDownload;

    /**
     * Specify transcript download icon in chat window if enabled
     *
     * @type {Boolean} tranDownload
     */
    tranDownloadIcon;

    /**
     * Holds configuration if add video in chat window is enabled
     *
     * @type {Boolean} addVideo
     */
    addVideo;

    /**
     * FIXME: this should be configured in LIVE
     *
     * Specify auto number for plans that will be use to add video to this chat
     *
     * @type {String} addVideoAutoNumber
     */
    addVideoAutoNumber;

    /**
     * Specify add video icon in chat window if enabled
     *
     * @type {String} addVideoIcon
     */
    addVideoIcon;

    /**
     * Holds configuration if add audio in chat window is enabled
     *
     * @type {Boolean} addAudio
     */
     addAudio;

     /**
      * FIXME: this should be configured in LIVE
      *
      * Specify auto number for plans that will be use to add audio to this chat
      *
      * @type {String} addAudioAutoNumber
      */
      addAudioAutoNumber;
 
     /**
      * Specify add audio icon in chat window if enabled
      *
      * @type {String} addAudioIcon
      */
     addAudioIcon;

    /**
     * Specify agent with which this window is connected buttons
     *
     * @type {String} agent
     */
    agent;

    /**
     * Specify initial message
     *
     * @type {String|Array} initMessage
     */
    initMessage;

    /**
     * Specify if chat window should be put in right drawer
     *
     * @type {Boolean} drawer
     */
    drawer;

    /**
     * Specify drawer icon
     *
     * @type {String} drawerIcon
     */
    drawerIcon;

    /**
     * Holds reference to drawer button
     *
     * @private {HTMLElement} drawerBtn
     */
    dBtn;

    /**
     * Holds message for chat
     *
     * @private {Array} messages
     */
    messages;

    /**
     * Holds reference to list Element
     *
     * @private {HTMLElement} listEl
     */
    listEl;

    /**
     * Holds reference to audio Element
     *
     * @private {HTMLElement} audioEl
     */
    audioEl;

    /**
     * Holds reference to input upload form Element
     *
     * @private {HTMLElement} selectFile
     */
    selectFile;

    /**
     * Holds reference to input Element
     *
     * @private {HTMLElement} inputEl
     */
    inputEl;

    /**
     * Holds reference to progress Element
     *
     * @private {HTMLElement} progressEl
     */
    progressEl;

    /**
     * Holds reference to typing task
     *
     * @private {Function} typingTask
     */
    typingTask;

    /**
     * Holds delay before end typing info is send to agent
     *
     * @type {Number} typingDelay
     */
    typingDelay;

    /**
     * Is typing in progress
     *
     * @private {Boolean} typing
     */
    typing;

    /**
     * Is chat connected
     *
     * @private {Boolean} connected
     */
    connected;

    /**
     * Is chat ended
     *
     * @private {Boolean} ended
     */
    ended;

    /**
     * Holds plan name for issued call
     *
     * @private {String} planName
     */
    planName;

    /**
     * Holds plan number for issued call
     *
     * @private {String} planNumber
     */
    planNumber;

    /**
     * Number of unread messages
     *
     * @private {Number} unreadMsg
     */
    unreadCount;

    /**
     * Chat info message recevied (in case we get it before CONNECTED signal)
     *
     * @private {Object} chatInfoMsg
     */
    chatInfoMsg;

    /**
     * List of HTMLElements that should be removed from view after chat ends
     *
     * @private {Array} chatEndRemoveEls
     */
    chatEndRemoveEls;

    /**
     * Indicates that adding video is in progress
     *
     * @private {Boolean} addingVideo
     */
    addingVideo;

    /**
     * Contains list of documents currently in chat
     *
     * @private {Object}
     */
    documents;

    /**

     * Is agent a bot
     *
     * @private {Boolean}
     */
    isBot;

    /**
     * Value that indicates if user wants to talk with agent and not with bot anymore
     *
     * @type {Boolean}
     */
    botToAgent;

    /**
     * Function to call agent directly
     *
     * @private {Function}
     */
    callAgentFn;

    /**
     * Function to destroy plans window
     *
     * @private {Function}
     */
    destroyPlansFn;

    /**
     * Queued signals
     *
     * @private {Object}
     */
    queuedSignals;

    /**
     * Bot configuration data
     * @type {Object}
     */
    botData;

//////////////////////////////////////////
    /**
     * GraphQL
     */
    graphQL;
//////////////

    /**
     * Time passed since the last client's message
     *
     * @type {Number} inactivityTimer
     */
    inactivityTimer;

    /**
     * constructor
     * @param {Object} config
     */
    constructor(config = {}) {
        // apply default config if not specified
        Utils.applyIf(config, {
            title            : a24n('Agent') + ': ' + config.agent,
            destroyOnClose   : true,
            minimizable      : true,
            typingDelay      : 500,
            agentIcon        : 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
            drawerIcon       : Svgs.CHAT,
            msgSound         : 'data:audio/mp3;base64,SUQzAwAAAAAAHVRJVDIAAAATAAAAR29vZ2xlIFRhbGsgTm90aWZ5//NIxAANuBItlEiCAAFl66/t AITRhwfB95QEAwUB8Py+GLPiA5v9Xb/5eJHaH//lJT/nP+QShby4P5PrD32eTs/yj9QJuSSSSSON pDcRdYBhyTFAa3x4la6nf7acWSa7bNDf2er1o7Nn//7P/+//XZdSkiXIopnZYwkLnpB2MxkKhUGe aNUBLEuS+sXlTkyE//NIxEwMcApqX0YQAopCdQRQCtO6bqrTRcDXrQMyDFHAy5wW4zL7swKPwMkg BQgAUAMSIk8fUaGi3JkTuAoAIqVyeMRbSBDHfitgBAAb4GyB9QbHyZROKUM1/BtoGqBOgb+RhOCM EzhXSoJf8GwgYIHKDVgpQexjBHg1jZTmKO53/8XIOwc8g583OE4LjSNB//NIxJ00VBbSX5igAnOz o+qy0v/+RNzc4ThPl8vjgWmdIuT5R9FkzX0Vr///y+boa006DPoNHMGUHB/qf7mpiarqABsvlE4+ 9NCIDkS5EXgUATGpfM2mEx+ExkDF1CYDhULGBZOYuCoGBJcFvYpCo1YGGi+YXYooCgegLiMKK4ow 6bibjuX1cgwQw/GnkU/z//NIxE4tNBacB9xAANx378RTsKKLskVPzcf/L/PZBjulOv8/d9b38JAp Lwk3/Pu5YuKU4ueIAeDQ/U+QfBeLDg7P4M4FDCBQeiTp//f/8vfwlIrwk3/f/VffdxRbiG4oKh/I qKipUKSOHMHQdUwnFiHHnDKQAe422jHatnLeO6/MuW0sAedL39lDpwKYkI9H//NIxBwj1Ba9nsmO 1jl9Hf/lORzZYlACSeCTmU2zNSj3qoJPhJMSlM/b6m/qa06yDZzWanNamjq02aaPElZH/9Dn9Gnf /8446pqHLlQFiKRGBKjoAoPQWgCgNByRMGpEeJPHjjfnOcdmmmqbO//f/8ua5Foyv46apY1UOmo4 QsXqBsttth0vzGINWAhBoNHU//NIxA8fxBa4fg5OTr34BfEwMhqadtFjmzjRQEBj2iYeozOAuchn vUVznNcUDj1Q0WGKzbLjpM08Wu7vcoecMsrHZzsfYg7E1NZWHKluzfR7aI+f///8qDl4ijZwsUJI pzKe9oiuEpQZHRJQkn//9vv/T/mF6fU3vtWJhGYP42mhVP3+s6jlRuxdYAZz8GXA//NIxBMhzA6Q XtoU10zt/HbUAAQGaXxCEA7clGrPgopOmw/lFWICCRldTF1UIxWqjRt3KWNhanq+pQisXd3S6b/u k1mIWUmUsymuYpvv+/9Kf///QACOzwUFg8CcXGxOUI2GpgxJThKInOFQYhZkidP/+33//7xcJ1f5 Ra0uxw+FVaAQrrrtqvtflhJFJImQ//NIxA4frBKxvpGO3unBlFtjMbgoIMjhdp9lo7ntplF1YgCg 4BbUWCpZmxv/XJMO7NUTn+pVv+P9dnl6EWjit1ueZb129TtySjpBUZVHUVv/R+9Ov///ygll4Pgu iFEQdIu48z1PNSOqGWV3ef/f6I6+/9pv8o//dk6I8qJKqAElt22z+q8VmdtZR0cyhbln//NIxBIa 6vapvg4OMv2kGFslyxFRVUN56buPOlphF1Sn0NQ68annHJci908qVEUkcgwcppd9XZHIoit7tYip Zx1DJ7dWTavpSbKf///PJl2iMp4LWQ53HVvMNkULkLGe7v6cO+n/Tajk7bdt9NQ3rLqC6YFDAtY5 hHmg6xogGSFpdY0T2NnXlihhcvVGS36o//NIxCkXQpqlvpDOyvVRWRVrMYN2Zd1VjD3kjjlMVVZT n9+bNNOSPmopjjte96Vf850OHTf///UAkgVusZ///+wQam5JHGm9ZikiTIzwIsBViqmakaSoEMBe jFJ0k11f/Ty/+D8QvcsfDayyNTvf56e6Iof/5k2RwTk//f1/KBibXFfZ3f2f3f1KNFH+SSWS//NI xE8SGpp8/pBVHjXnZ/pJYWVK8s70bIWM2v6L+1fpq3/5VrpX/W31/lbt/9rf/q9ejq/Zfr/0/X9A 0Y9n///4y6P/6UxBTUUzLjk5LjWqqqqqqqqqqqqqONLjccklka9uX2UQVxjRbwHYXwdEbg1DVp/3 t/T/+/9v/6X//7f//1//3/vrv+ltxMBU//19//NIxIkPwp6Fng4KTru7eon/d9NMQU1FMy45OS41 VVVVVVVVVVVVVVVVVVVVVVVVVVUPf/rB3f/Wu573GBVZA1r1qy1qJNZA7Maswq9/P2Z65aLYKJZF l6TdZZ0fmH4UosqtGuKqLvNlU2/pVDO67bdG01nZHbWwzZJN8uLkHTR13OFDxkTxSnaoQjTpVj3k //NIxLkPOqKFvgvKTkq0PJLjCKpMQU1FMy45OS41qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqLan+SSRxteCZ7lYxSYsTNm4kZ4Tx Vi3V2af0d1vSm1i/qeh213pXR//jP26dosN2/dK///NIxOEZCqJINMhE/NJ3mbVT0tVMQU1FMy45 OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV VVVVVVUlUpuSW2Sxny2y20WAQmf5KAKJVtZoCkAqAiQ9FSGD03ktDPaeLX7eRlist5Z7Zb//1+za v8nq//NIxLYOWF55ngvCTv//Eqf/5JVMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVQnBbbbcKTUViyHiooLFAsJDmCzVs6xWKEn4sa/W LI1cVFuKaxUW1ijf7NYq3WKZUKiweNAyKCxoCios1H////NIxLoPUGJ1vgmSEusU/AoVFBZMQU1F My45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV VVVVVVVV//NIxMERQAXgfghEAlVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV',
            fileUpload       : false,
            fileUploadIcon   : Svgs.UPLOAD,
            tranDownload     : true,
            tranDownloadIcon : 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z'
////////////////////////////////////////////////////////
            , addVideo       : true,
            addVideoIcon     : Svgs.VIDEO
//////////////////////
////////////////////////////////////////////////////////
            , addAudio       : true,
            addAudioIcon     : Svgs.AUDIO
//////////////////////
        });

/////////////////////////////////////////////////////////////
////////////////////////////////
//////////////////

/////////////////////////////////////////////////////////////
////////////////////////////////
//////////////////

        // call the parent class' constructor
        super(config);

        Utils.apply(this, config);
    }

    /**
     * Init component
     *
     * @private
     */
    initComponent() {
        super.initComponent();

        // DOMPurify config
        this.dPCfg = {
            ALLOWED_TAGS : ['b', 'i', 'u', 'br'],
            ADD_ATTR     : []
        };

        if (Asseco.config.allowSendingAndReceivingLinks === true) {
            this.dPCfg.ALLOWED_TAGS.push('a');
            this.dPCfg.ADD_ATTR.push('target');
        }

        this.messages = [];
        this.unreadCount = 0;
        this.chatEndRemoveEls = [];

        this.typingTask = new Utils.DelayedTask(this.onTyping, this);
    }

    /**
     * Load this component style (loaded css is added to head)
     *
     * @private
     */
    getStyle() {
        super.getStyle();
        require('./Window.scss');
    }

    /**
     * Return content for card
     *
     * @private
     */
    getContentHtml() {
        var message = '';
        if (! Utils.isEmpty(this.initMessage)) {
            if (Array.isArray(this.initMessage)) {
                message = this.initMessage.join('');
                this.messages = this.initMessage;
            } else {
                message = require('babel-loader!template-string-loader!./Agent.html')({
                    agentIcon : Utils.getIconMarkup(this.agentIcon, '', '', '#000'),
                    message   : this.initMessage.trim(),
                    time      : Utils.getLocaleTime()
                });
                this.messages.push(message);
            }
        }

        return require('babel-loader!template-string-loader!./Window.html')({
            drawer           : this.drawer,
            fileUpload       : this.fileUpload,
            fileUploadIcon   : Utils.getIconMarkup(this.fileUploadIcon, '', '', '#000'),
            tranDownload     : this.tranDownload,
            tranDownloadIcon : Utils.getIconMarkup(this.tranDownloadIcon, '', '', '#000'),
            addVideo         : this.addVideo && this.addVideoAutoNumber,
            addVideoIcon     : Utils.getIconMarkup(this.addVideoIcon, '', '', '#000'),
            addAudio         : this.isBot && this.addAudio && this.addAudioAutoNumber,
            addAudioIcon     : Utils.getIconMarkup(this.addAudioIcon, '', '', '#000'),
            textInId         : 'asseco-chat-window-input-text',
            textTip          : a24n('Text'),
            textSend         : a24n('Send'),
            initMessage      : message,
            msgSound         : this.msgSound,
            isBot            : this.isBot,
            callAgentIcon    : Utils.getIconMarkup(this.agentIcon, '', '', '#000'),
            charLimit        : Asseco.config.maxCharCount
        });
    }

    /**
     * Called after component is rendered
     *
     * @private
     */
    afterRender() {
        super.afterRender();

        // ensure css class for asseco chat window
        Element.addClass(this.containerEl, 'asseco-chat-window');

        if (Asseco.fsUA) {
            // add callback for SIP message
            Asseco.fsUA.on('message', this.onSipMessageReceived.createDelegate(this));

            // attach listener for FS disconnected
            Asseco.fsUA.on('disconnected', this.onFsDisconnected.createDelegate(this));
        }

        // add listener for window beforeunload
        window.addEventListener('beforeunload', this.onBeforeWindowUnload.createDelegate(this));

        // add listener for window unload (only for Chat because for Videochat it is handled by FS session)
        if (this.__proto__.xtype === 'LiveChatWindow') {
            window.addEventListener('unload', this.onWindowUnload.createDelegate(this));
        }

        // register dynamic material design components
        this.inputEl = this.getEl('.mdl-textfield');
        this.cHU(this.inputEl);

        if (this.drawer) {
            this.initDrawer();
        }

        // attach keyup event to input element for sending text
        this.inputEl.onkeyup = (e) => {
            // send typing signal
            if (! this.typing) {
                this.typing = true;
                this.onTyping(Constants.SIGNAL_TYPINGSTARTED);
            }
            this.typingTask.delay(this.typingDelay, null, null, [Constants.SIGNAL_TYPINGENDED]);

            // send message on ENTER
            if (e.keyCode === 13  && ! e.shiftKey) {
                var msg = e.target.value.trim();
                if (! Utils.isEmpty(msg)) {
                    this.onMessageSend(e.target, msg);
                }
            }
        };

        // attach click event to send button for sending text
        this.getEl('.asseco-chat-window-send button').onclick = () => {
            var target = this.inputEl.MaterialTextfield.input_,
                msg = target.value.trim();

            if (! Utils.isEmpty(msg)) {
                this.onMessageSend(target, msg);
            }
        };

        // save reference to list element
        this.listEl = this.getEl('.asseco-chat-window-list');

        // save reference to audio element
        this.audioEl = this.getEl('#asseco-chat-msg-sound');

        // add top toolbar buttons
        this.addTbarBtns();

        // disable LiveVideoChat, LiveAudioChat
        CmpMgr.updateComponents(['LiveVideoChat', 'LiveAudioChat'], 'disable');

        // enable LiveCobrowsing
        CmpMgr.updateComponents(['LiveCobrowsing'], 'enable');

        // we already have info message
        if (! Utils.isEmpty(this.chatInfoMsg)) {
            this.onFsInfoMessage(this.chatInfoMsg);
        }

        // attach handlers to documents (we use it to reattach event to document icons when upgrading chat to videochat)
//////////////////////////////////////////////////////
        this.attachDocumentsHandlers();
//////////////////

//////////////////////////////////////////////
        var self = this;
        if (this.isBot && this.botData && this.botData.type && this.botData.type === 'codewell') {
            this.graphQL = new GraphQL(this.botData.url);
      
            this.graphQL.subscribeForNewMessages(Asseco.UUID)
                .subscribe(function (data) {
                    console.log('New message', data);
                    if (data && data.data && data.data.messages) {
                        var message = data.data.messages;
                        if (message.sender === 'bot' && message.type === 'TEXT') {
                            var msgData = { body : message.text};
                            self.onFsBodyMessage(msgData);


                            if (message.buttons) {
                                var options = '';
                                message.buttons.forEach(function (button) {
                                    options += '- ' + button.description + '\n';
                                });
                                // Remove \n from the end
                                options = options.substring(0, options.length - 2);
                                var optData = { body : options};
                                self.onFsBodyMessage(optData);
                            }
                        }
                    }
                });

            var messageMutation = {
                msg: 'Hi',
                hidden: false,
                value: '',
                buttonLink: '',
                sender: Asseco.UUID,
                msgType: 'message'
            };

            this.graphQL.sendMessageMutation(messageMutation)
                .then(data => console.log('Mutation result', data))
                .catch(error => console.error(error));

        } else if (this.isBot) {
            this.botRegister();
        }
//////////////////
    }

    /**
     * Executed before component is destroyed (return false to cancel Destroy)
     *
     * @return {Boolean}
     * @private
     */
    beforeDestroy() {
        // remove typing task
        if (this.typingTask) {
            this.typingTask.cancel();
            this.typingTask = null;
        }

        if (! this.connected) {
            // enable LiveVideoChat, LiveAudioChat
            CmpMgr.updateComponents(['LiveVideoChat', 'LiveAudioChat'], 'enable');

/////////////////////////////////////////////////////////
            // disable LiveCobrowsing
            CmpMgr.updateComponents(['LiveCobrowsing'], 'disable');
//////////////////////
        }

        if (! this.addingVideo) {
            // send disconnect signal and disconnect from FS
            if (Asseco.fsUA && ! this.botToAgent) {
                // send disconnect signal
                this.sendFSMessage(null, [{
                    category : Constants.MSG_CAT_SIGNAL,
                    name     : Constants.SIGNAL_DISCONNECTED
                }]);

                // disconnect from FS
                console.log('LiveChatWindow::Closing SIP UA...');
                Asseco.fsUA.stop();
                Asseco.fsUA = null;
            }

            if (Connection.getStatus() === Connection.OPEN && ! this.botToAgent) {
                Connection.close();
            }
        }

        // remove window close listener
        window.removeEventListener('beforeunload', this.onBeforeWindowUnload.createDelegate(this));
        window.removeEventListener('unload', this.onWindowUnload.createDelegate(this));

        // set connected status
        this.connected = false;

//////////////////////////////////////////////
        if (this.isBot && ! this.botToAgent && typeof this.destroyPlansFn === 'function') {
            this.destroyPlansFn();
        }
//////////////////

        return true;
    }

    /**
     * Add top toolbar buttons
     *
     * @private
     */
    addTbarBtns() {
        // download transcript
        if (this.tranDownload) {
            var dTElId = 'asseco-chat-window-downloadTranscript';
            this.getEl('#' + dTElId).onclick = (e) => {
                this.onDownloadTranscript();
                e.preventDefault();
            };
            this.tips.push(Utils.tooltip(dTElId, a24n('Download transcript')));
        }

////////////////////////////////////////////////////
        // add video
        if (this.addVideo && this.addVideoAutoNumber) {
            var addVElId = 'asseco-chat-window-addVideo';

            var addVTip = Utils.tooltip(addVElId, a24n('Add video'));
            this.tips.push(addVTip);

            this.getEl('#' + addVElId).onclick = (e) => {
                // make sure tooltip is hidden before click is triggered
                if (addVTip && addVTip.MaterialTooltip) {
                    addVTip.MaterialTooltip.hideTooltip_();
                }

                Element.disabledElement(addVElId);
                this.onAddVideo();
                e.preventDefault();
            };
        }
//////////////////

////////////////////////////////////////////////////
        // add audio
        if (this.isBot && this.addAudio && this.addAudioAutoNumber) {
            var addAElId = 'asseco-chat-window-addAudio';

            var addATip = Utils.tooltip(addAElId, a24n('Add audio'));
            this.tips.push(addATip);

            this.getEl('#' + addAElId).onclick = (e) => {
                // make sure tooltip is hidden before click is triggered
                if (addATip && addATip.MaterialTooltip) {
                    addATip.MaterialTooltip.hideTooltip_();
                }

                Element.disabledElement(addAElId);
                this.onAddAudio();
                e.preventDefault();
            };
        }
//////////////////

        // upload file
        if (this.fileUpload) {
            var uplElId = 'asseco-chat-window-uploadFile';

            this.selectFile = this.getEl('#asseco-chat-window-selectFile');
            this.selectFile.onchange = (e) => {
                Element.disabledElement(uplElId);
                this.getUploadKey();
                e.preventDefault();
            };

            var fTip = Utils.tooltip(uplElId, a24n('Send file'));
            this.tips.push(fTip);

            this.getEl('#' + uplElId).onclick = (e) => {
                if (this.selectFile) {
                    // make sure tooltip is hidden before click is triggered
                    if (fTip && fTip.MaterialTooltip) {
                        fTip.MaterialTooltip.hideTooltip_();
                    }

                    this.selectFile.click();
                }
                e.preventDefault();
            };

            // save reference to progress element
            this.progressEl = this.getEl('#asseco-chat-window-progressBar');
            Element.addClass(this.progressEl, 'asseco-hidden');
        }

//////////////////////////////////////////////
        if (this.isBot) {
            var cAId = 'asseco-chat-window-callAgent';
            this.getEl('#' + cAId).onclick = (e) => {
                e.preventDefault();
                if (typeof this.callAgentFn === 'function') {
                    this.botToAgent = true;
                    this.destroy();
                    this.callAgentFn();
                }
            };
            this.tips.push(Utils.tooltip(cAId, a24n('Call agent')));
        }
//////////////////
    }

    /**
     * Init drawer
     *
     * @private
     */
    initDrawer() {
        this.cHU(this.getEl('.mdl-layout'));
        this.updateDrawerBtn();

        Element.addClass(this.containerEl, 'has-drawer');
    }

    /**
     * Update drawer icon
     *
     * @private
     */
    updateDrawerBtn() {
        if (this.drawerIcon && ! this.dBtnUpdated) {
            var dB = this.getEl('.mdl-layout__drawer-button');
            if (dB) {
                Element.addClass(dB, 'mdl-button--fab');
                Element.setStyle(dB, {
                    borderRadius : 0,
                    minWidth     : '40px',
                    width        : '40px',
                    height       : '40px'
                });

                dB.innerHTML = Utils.getIconMarkup(this.drawerIcon);
                this.dBtnUpdated = true;

                this.dBtn = dB;
                this.dBtn.onclick = this.onDrawerBtnClick.createDelegate(this);

                return;
            }
            this.updateDrawerBtn.defer(100, this);
        }
    }

    /**
     * Executed before window unload
     *
     * @param {Event} e
     * @private
     */
    onBeforeWindowUnload(e) {
        if (this.connected) {
            let msg = a24n('You have active chat! Do you really want to close window?');
            e.returnValue = msg;
            return msg;
        }
        return;
    }

    /**
     * Executed on window unload
     *
     * @private
     */
    onWindowUnload() {
        if (this.connected) {
            this.beforeDestroy();
        }
    }

    /**
     * Executed when close button is clicked
     */
    onClose() {
        if (this.connected) {
            Utils.dialog('', a24n('Do you want to end chat with agent?'), [{
                text: a24n('No'),
                handler: (d) => d.close()
            }, {
                text: a24n('Yes'),
                scope: this,
                handler: (d) => {
                    this.addingVideo = false;

                    d.close();

                    // send disconnected signal
                    var sm = {};
                    sm[Constants.MSG_CAT_SIGNAL] = {};
                    sm[Constants.MSG_CAT_SIGNAL][Constants.SIGNAL_DISCONNECTED] = '';
                    this.onFsSignalMessage(sm);

                    // disconnect
                    this.beforeDestroy.defer(250, this);
                }
            }]);
        } else {
            super.onClose();
        }
    }

    /**
     * Executed when minimize buttons is clicked
     *
     * @private
     */
    onMinimize() {
        super.onMinimize();

        let cF = CmpMgr.getByXtype(this.__proto__.xtype.replace('Window', ''));
        if (cF) {
            let cfEl = cF.containerEl;
            Element.addBadge(cfEl, '▽', false, 'red');
        }
    }

    /**
     * Executed when card is restored for minimized state
     *
     * @private
     */
    onRestore() {
        super.onRestore();
        this.unreadCount = 0;

        let cF = CmpMgr.getByXtype(this.__proto__.xtype.replace('Window', ''));
        if (cF) {
            Element.removeBadge(cF.containerEl);
        }
    }

    /**
     * Executed on drawer button click
     *
     * @private
     */
    onDrawerBtnClick() {
        this.unreadCount = 0;
        if (this.dBtn) {
            Element.removeBadge(this.dBtn);
        }
    }

    /**
     * Executed on typing
     *
     * @param {String} a Typing action (TYPINGSTARTED, TYPINGENDED)
     */
    onTyping(a) {
        if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
            clearTimeout(this.inactivityTimer);
        }

        if (a === Constants.SIGNAL_TYPINGENDED) {
            this.typing = false;
            if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
                this.startInactivityTimer();
            }
        }

        if (! this.isBot) {
            // send message via SIP client
            this.sendFSMessage(null, [{
                category : Constants.MSG_CAT_SIGNAL,
                name     : a
            }]);
        }
    }

    /**
     * Executed on chat start
     *
     * @private
     */
    onChatStart() {
        console.log('LiveChatWindow::onChatStart');

        // Try to find the only visible textarea used in the chat input
        const textarea = document.querySelector('.asseco-chat-window-input textarea');
        const charCount = document.getElementById('charCount');
        const charLimit = textarea ? parseInt(textarea.getAttribute('maxlength')) : null;

        if (textarea && charCount) {
            textarea.addEventListener('input', function () {
                const currentLength = textarea.value.length;

                if (charLimit && currentLength > charLimit) {
                    textarea.value = textarea.value.substring(0, charLimit);
                }

                charCount.textContent = charLimit
                    ? `${textarea.value.length} / ${charLimit}`
                    : `${textarea.value.length} / ∞`;
            });

            const initialLength = textarea.value.length;
            charCount.textContent = charLimit
                ? `${initialLength} / ${charLimit}`
                : `${initialLength} / ∞`;
        } else {
            console.warn('Textarea or charCount element not found');
        }
    }

    /**
     * Executed on receiving disconnected signal
     *
     * @private
     */
    onChatEnd() {
        console.log('LiveChatWindow::onChatEnd');

        this.chatEndRemoveEls.forEach(el => {
            Element.removeNode(el);
        });

        // set connected status
        this.connected = false;

        // process queued signals for diconnect event
        if (this.queuedSignals && this.queuedSignals.hasOwnProperty('disconnected') && ! Utils.isEmpty(this.queuedSignals.disconnected)) {
            this.queuedSignals.disconnected.forEach(s => {
                this.onFsSignalMessage(s);
            });
        }
    }

    startInactivityTimer() {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = setTimeout(() => {
            console.log('Closing inactive chat...');

            this.onChatEnd();

            var message = require('babel-loader!template-string-loader!./Agent.html')({
                agentIcon : Utils.getIconMarkup(this.agentIcon, '', '', '#000'),
                message   : '<i>' + a24n('End communication') + '</i>',
                time      : Utils.getLocaleTime()
            });
            this.addNewMessage(message);

            // disconnect
            this.beforeDestroy.defer(250, this);
        }, Asseco.config.inactivityTimeout);
    }

    /**
     * Send instant message
     *
     * @param {HTMLElement} el Button element that was clicked
     * @param {String} msg Message to be sent
     * @private
     */
    onMessageSend(el, msg) {
        if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
            clearTimeout(this.inactivityTimer);
        }
        // replace new line in msg with br
        msg = msg.replace(/(?:\r\n|\r|\n)/g, '<br />');

        // clean msg with DOMPurify before send
        msg = require('dompurify').sanitize(msg, this.dPCfg).trim();
        if (Utils.isEmpty(msg)) {
            return;
        }

        // send message via SIP client
        if (Asseco.fsUA) {
            // send message via SIP client
            this.sendFSMessage(msg);
        }

//////////////////////////////////////////////
        else if (this.isBot) {
            if (this.botData && this.botData.type && this.botData.type === 'codewell') { 
                var messageMutation = {
                    msg: msg,
                    hidden: false,
                    value: '',
                    buttonLink: '',
                    sender: Asseco.UUID,
                    msgType: 'message'
                };

                this.graphQL.sendMessageMutation(messageMutation)
                    .then(data => console.log('Mutation result', data))
                    .catch(error => console.error(error));
            
            } else {
                this.sendBotMessage(msg);
            }
        }
//////////////////

        // use Autolinker
        msg = require('autolinker').link(msg, {stripPrefix: false});

        var message = require('babel-loader!template-string-loader!./Client.html')({
            message : msg,
            time    : Utils.getLocaleTime()
        });

        this.listEl.insertAdjacentHTML('beforeend', message);
        this.messages.push(message);

        // reset input field value
        if (el) {
            el.value = '';
        }

        // scroll to botto of the content
        this.listEl.scrollTop = this.listEl.scrollHeight;
    }

    /**
     * Executed on message send fail
     *
     * @param {SIP.IncomingMessage} r
     * @param {String} c
     */
    onMessageSendFailed(r, c) {
        var message = require('babel-loader!template-string-loader!./Client.html')({
            message : '<i style="font-size: 12px;">' + String.format(a24n('Sending message failed ({0})'), c) + '</i>',
            time    : Utils.getLocaleTime()
        });

        this.listEl.insertAdjacentHTML('beforeend', message);
        this.messages.push(message);

        // scroll to botto of the content
        this.listEl.scrollTop = this.listEl.scrollHeight;

///////////////////////////////
/////////////////////////////////////////////////////////////////////////////
///////////////////////
//////////////////////
//////////////////
    }

    /**
     * Executed when SIP message is received
     *
     * @param {Object} m
     * @private
     */
    onSipMessageReceived(m) {
        var d = JSON.parse(m.body);

        // message received from service (e.g. ping, unregistered)
        if (d.hasOwnProperty('info')) {
            this.onFsServiceMessage(d);
            return;
        }

        // fetch message meta data
        var mData = {};
        ('meta' in d ? (Array.isArray(d.meta) ? d.meta : [d.meta]) : []).forEach(m => {
            mData[m.category] = mData[m.category] || {};
            mData[m.category][m.name] = m.value;
        }, this);

        // process SIGNAL message
        if (Constants.MSG_CAT_SIGNAL in mData) {
            this.onFsSignalMessage(mData);
        }
        // process INFO message
        else if (Constants.MSG_CAT_INFO in mData) {
            this.onFsInfoMessage(mData);
        }
        // show body message
        else if (! Utils.isEmpty(d.body)) {
            if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
                this.startInactivityTimer(); // start timer on agent's message
            }
            this.onFsBodyMessage(d);
        }
    }

    /**
     * Executed on receiving service message from SIP UA
     *
     * @param {Object} d
     * @private
     */
    onFsServiceMessage(d) {
        var err;

        if (d.info.hasOwnProperty('unregistered') && d.info.unregistered) {
            err = a24n('User unregistered / Chat expired');
            console.warn('LiveChatWindow - User unregistered');

        }
        else if (d.info.hasOwnProperty('disconnected') && d.info.disconnected) {
            err = a24n('User disconnected');
            console.warn('LiveChatWindow - User disconnected');
        }

        if (! Utils.isEmpty(err)) {
            Utils.dialog(a24n('Error'), err);

            var message = require('babel-loader!template-string-loader!./Agent.html')({
                agentIcon : Utils.getIconMarkup(this.agentIcon, '', '', '#000'),
                message   : '<i>' + err + '</i>',
                time      : Utils.getLocaleTime()
            });
            this.addNewMessage(message);

            // disable text field input (on disconnect and on hold)
            this.inputEl.MaterialTextfield.input_.disabled = true;

            // disable file upload (on disconnect and on hold) if available
            if (this.fileUpload) {
                this.getEl('#asseco-chat-window-selectFile').disabled = true;
                this.getEl('#asseco-chat-window-uploadFile').disabled = true;
            }

            // disable add video (on disconnect and on hold) if available
            if (this.addVideo) {
                this.getEl('#asseco-chat-window-addVideo').disabled = true;
            }

            // disable add audio (on disconnect and on hold) if available
            if (this.addAudio) {
                this.getEl('#asseco-chat-window-addAudio').disabled = true;
            }

            this.onChatEnd();

///////////////////////////////////
////////////////////////////////////
//////////////////////
///////////////////////
//////////////////////

            if (Asseco.fsUA) {
                console.log('LiveChatWindow::Closing SIP UA...');
                Asseco.fsUA.stop();
                Asseco.fsUA = null;
            }
        }
    }

    /**
     * Executed on receiving SIGNAL message in SIP message
     *
     * @param {Object} mData
     * @private
     */
    onFsSignalMessage(mData) {
        var ms = mData[Constants.MSG_CAT_SIGNAL],

            tElId = '#asseco-chat-window-typing',
            tSCls = 'asseco-chat-window-typing-start',
            tECls = 'asseco-chat-window-typing-end';

        if (Constants.SIGNAL_RDSUPDATE in ms) {
            console.log('LiveChatWindow::onFsSignalMessage - got client update signal');
            var rds = CmpMgr.getByXtype('LiveFilemanagerRds');
            if (rds && rds.currentStep === LiveFilemanagerRds.STEP_CERT_USER_DATA) {
                rds.getUserData.call(rds, true, true);
            }
        }
        else if (Constants.SIGNAL_TYPINGSTARTED in ms) {
            Element.replaceClass(this.getEl(tElId), tECls, tSCls);
            if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
                clearTimeout(this.inactivityTimer);
            }
        }
        else if (Constants.SIGNAL_TYPINGENDED in ms) {
            Element.replaceClass(this.getEl(tElId), tSCls, tECls);
            if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
                this.startInactivityTimer();
            }
        }
        else if (
            Constants.SIGNAL_DISCONNECTED in ms ||
            Constants.SIGNAL_HOLD         in ms ||
            Constants.SIGNAL_OFFHOLD      in ms ||
            Constants.SIGNAL_NEWDOCUMENT  in ms ||
            Constants.SIGNAL_DELDOCUMENT  in ms ||
            Constants.SIGNAL_SCRIPTER
        ) {
            var sm, sv, svName, uuidP, uuidS;
            if (Constants.SIGNAL_DISCONNECTED in ms) {
                // not connected
                if (! this.connected) {
                    return;
                }
                sm = a24n('End communication');
                this.onChatEnd();
            } else if (Constants.SIGNAL_HOLD in ms) {
                sm = a24n('On hold');
                if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
                    clearTimeout(this.inactivityTimer);
                }
            } else if (Constants.SIGNAL_OFFHOLD in ms) {
                sm = a24n('Off hold');
                if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
                    this.startInactivityTimer();
                }
            } else if (Constants.SIGNAL_SCRIPTER in ms) {
                sv = JSON.parse(ms[Constants.SIGNAL_SCRIPTER]);

                // queue this SIGNAL if event is disconnect and we are connected
                if ((sv['event'] || 'disconnect') === 'disconnect' && this.connected) {
                    console.log('Queueing signal (' + Constants.SIGNAL_SCRIPTER + ') for disconnect');
                    this.queuedSignals = this.queuedSignals || {};
                    this.queuedSignals.disconnected = this.queuedSignals.disconnected || [];
                    this.queuedSignals.disconnected.push(mData);
                    return;
                }

                uuidP = 'btn-scripter-' + sv.id;

                sm = sv.template.replace('{Scripter.Script.name}', sv.scripter +
                    ' <button id="' + uuidP + '" class="mdl-button mdl-button--icon">' +
                        Utils.getIconMarkup('M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z', '', '', '#000') +
                    '</button>');
            } else if (Constants.SIGNAL_NEWDOCUMENT in ms || Constants.SIGNAL_DELDOCUMENT in ms) {
                if (Asseco.config.hasOwnProperty('closeInactiveChat') && Asseco.config.closeInactiveChat == true) {
                    clearTimeout(this.inactivityTimer);
                }
                sv = JSON.parse(
                    Constants.SIGNAL_NEWDOCUMENT in ms
                        ? ms[Constants.SIGNAL_NEWDOCUMENT]
                        : ms[Constants.SIGNAL_DELDOCUMENT]
                );
                svName = typeof LiveFilemanagerWindow !== 'undefined' ? LiveFilemanagerWindow.displayFolderName(sv.name) : sv.name;
                uuidP = 'btn-preview-' + sv.id;
                uuidS = 'btn-sign-' + sv.id;

                if (Constants.SIGNAL_NEWDOCUMENT in ms) {
                    sm = String.format(a24n('<b>New documents:</b><br> {0}'), svName +
                        ' <button id="' + uuidP + '" class="mdl-button mdl-button--icon">' +
                            Utils.getIconMarkup(Svgs.FILE, '', '', '#000') +
                        '</button>' +
                        ' <button id="' + uuidS + '" class="mdl-button mdl-button--icon">' +
                            Utils.getIconMarkup(Svgs.AUTH, '', '', '#000') +
                        '</button>');

                    // add document to documents list
                    this.documents = this.documents || {};
                    this.documents[sv.id] = {
                        sv    : sv,
                        uuidP : uuidP,
                        uuidS : uuidS
                    };
                } else {
                    sm = String.format(a24n('<b>Documents deleted:</b><br> {0}'), svName);

                    // remove tooltips and buttons for deleted documents
                    [uuidP, uuidS].forEach(u => {
                        var t = this.getEl('.mdl-tooltip[for="' + u + '"]');
                        if (t) {
                            Element.removeNode(t);
                        }

                        var b = this.getEl('#' + u);
                        if (b) {
                            Element.removeNode(b);
                        }
                    });

                    // remove document from documents list
                    this.documents = this.documents || {};
                    delete this.documents[sv.id];
                }
            }

            if (sm) {
                this.addNewMessage(require('babel-loader!template-string-loader!./Agent.html')({
                    agentIcon : Utils.getIconMarkup(this.agentIcon, '', '', '#000'),
                    message   : '<i>' + sm + '</i>',
                    time      : Utils.getLocaleTime()
                }));
            }

            var ds = Constants.SIGNAL_DISCONNECTED in ms || Constants.SIGNAL_HOLD in ms;

            // disable text field input (on disconnect and on hold)
            this.inputEl.MaterialTextfield.input_.disabled = ds;

            // disable file upload (on disconnect and on hold) if available
            if (this.fileUpload) {
                this.getEl('#asseco-chat-window-selectFile').disabled = ds;
                this.getEl('#asseco-chat-window-uploadFile').disabled = ds;
            }

            // disable add video (on disconnect and on hold) if available
            if (this.addVideo) {
                this.getEl('#asseco-chat-window-addVideo').disabled = ds;
            }

            // disable add audio (on disconnect and on hold) if available
            if (this.addAudio) {
                this.getEl('#asseco-chat-window-addAudio').disabled = ds;
            }

//////////////////////////////////////////////////////////
            if (Constants.SIGNAL_NEWDOCUMENT in ms && sv) {
                this.attachDocumentsHandlers(sv.id);
            }
//////////////////////

/////////////////////////////////////////////////////
            if (Constants.SIGNAL_SCRIPTER in ms && uuidP) {
                var pTip = Utils.tooltip(uuidP, a24n('View'));
                this.tips.push(pTip);

                var pBtn = this.getEl('#' + uuidP);
                pBtn.onclick = (e) => {
                    this.openSurveyWindow(sv, pBtn);
                    e.preventDefault();
                };
            }
//////////////////////
        }
    }

//////////////////////////////////////////////////
    /**
     * Attach document handlers
     *
     * @params {String} id
     */
    attachDocumentsHandlers(id) {
        if (! this.documents) {
            return;
        }

        var docs;
        if (id) {
            docs = {};
            docs[id] = this.documents[id];
        } else {
            docs = this.documents;
        }

        // function for handling document preview button click
        var pBtnF = (e, sv) => {
            this.openFmWindow(sv);
            e.preventDefault();
        };

        // function for handling document sign button click
        var sBtnF = (e, sv, sTip, sBtn) => {
            var authTypes = {};

/////////////////////////////////////////////////////////
            authTypes.Rds = LiveFilemanagerRds;
//////////////////////

////////////////////////////////////////////////////////////
            authTypes.mToken = LiveFilemanagermToken;
//////////////////////

            var opt = sv.conf.options;
            if (authTypes.hasOwnProperty(opt.authorization)) {
                // close any opened auth window
                var ew = CmpMgr.getByXtype(authTypes[opt.authorization].prototype.xtype);
                if (ew) {
                    ew.hide(true);
                }

                new authTypes[opt.authorization]({
                    folder: sv,
                    onSuccess: (m, f) => {
                        // remove sign button and tooltip
                        Element.removeNode(sTip);
                        Element.removeNode(sBtn);

                        // add button to dialog text
                        if (f) {
                            var uuidP = 'btn-' + Utils.generateUUID(5, 'id_');
                            m += ' <button id="' + uuidP + '" class="mdl-button mdl-button--icon">' +
                                    Utils.getIconMarkup(Svgs.FILE, '', '', '#000') +
                                '</button>';
                        }

                        // show notification
                        var d = Utils.dialog('', m);

                        if (f) {
                            // this.tips.push(Utils.tooltip(uuidP, a24n('View')));
                            document.querySelector('#' + uuidP).onclick = (e) => {
                                // close current dialog
                                if (d && d.hasAttribute('open')) {
                                    d.close();
                                }
                                this.openFmWindow(f);
                                e.preventDefault();
                            };
                        }

                        // send message to agent
                        this.onMessageSend(null, '<i>' + m + '</i>');
                    }
                });
            }
            e.preventDefault();
        };

        for (var i in docs) {
            if (docs.hasOwnProperty(i)) {
                var sv    = docs[i].sv,
                    uuidP = docs[i].uuidP,
                    uuidS = docs[i].uuidS;

                // attach handler to file preview button
                if (uuidP) {
                    var pTip = Utils.tooltip(uuidP, a24n('View'));
                    this.tips.push(pTip);

                    var pBtn = this.getEl('#' + uuidP);
                    pBtn.onclick = pBtnF.createDelegate(this, [sv], true);

                    if (sv.conf.options.online) {
                        this.chatEndRemoveEls.push(pTip);
                        this.chatEndRemoveEls.push(pBtn);
                    }
                }

                // attach handler to file sign button
                if (uuidS) {
                    var sTip = Utils.tooltip(uuidS, a24n('Authorize documents'));
                    this.tips.push(sTip);

                    var sBtn = this.getEl('#' + uuidS);
                    sBtn.onclick = sBtnF.createDelegate(this, [sv, sTip, sBtn], true);

                    if (sv.conf.options.online) {
                        this.chatEndRemoveEls.push(sTip);
                        this.chatEndRemoveEls.push(sBtn);
                    }
                }
            }
        }
    }
//////////////

    /**
     * Executed on receiving INFO message in SIP message
     *
     * @param {Object} mData
     * @private
     */
    onFsInfoMessage(mData) {
        if ('agentFirstName' in mData[Constants.MSG_CAT_INFO]) {
            this.agent = mData[Constants.MSG_CAT_INFO].agentFirstName;

            let aPref;
            switch (this.__proto__.xtype)
            {
            case 'LiveAudioChatWindow':
                aPref = a24n('Audio conversation');
                break;

            case 'LiveVideoChatWindow':
                aPref = a24n('Video conversation');
                break;

            default:
                aPref = a24n('Chat conversation');
                break;
            }

            this.getEl('.mdl-card__title-text').innerHTML = aPref + ': ' + 'HEP Elektra';
        }

        // save agent sip name to sip UA
        Asseco.fsUA.agentSipName = mData[Constants.MSG_CAT_INFO].agentSipName;
        console.log('LiveChatWindow::onFsInfoMessage - agent SIP name: ' + Asseco.fsUA.agentSipName);

        // set connected status
        this.connected = true;

        this.onChatStart();
    }

    /**
     * Executed on receiving body message in SIP message
     *
     * @param {Object} d
     * @private
     */
    onFsBodyMessage(d) {
        // replace new line in msg with br
        d.body = d.body.replace(/(?:\r\n|\r|\n)/g, '<br />');

        d.body = require('dompurify').sanitize(d.body, this.dPCfg).trim();
        if (Utils.isEmpty(d.body)) {
            return;
        }

        // use Autolinker
        d.body = require('autolinker').link(d.body, {stripPrefix: false});

        d.body = this.replaceHostname(d.body);

        this.addNewMessage(require('babel-loader!template-string-loader!./Agent.html')({
            agentIcon : Utils.getIconMarkup(this.agentIcon, '', '', '#000'),
            message   : d.body,
            time      : Utils.getLocaleTime()
        }));
    }

    /**
     * Executed on replacing hostname
     *
     * @param {Object} d
     * @private
     */
    replaceHostname(d){
        var replaceHostname = Asseco && Asseco.hasOwnProperty('config') && Asseco.config.hasOwnProperty('replaceHostname') ? Asseco.config.replaceHostname : '';
        if(replaceHostname && replaceHostname.replaceFrom && replaceHostname.replaceTo) {
            if (d.includes('filemanager') && d.includes('href')) {
                d = d.replace(replaceHostname.replaceFrom, replaceHostname.replaceTo);
                // Additional replace if the link has come with .local host part
                if(replaceHostname.replaceFromCustom){
                    d = d.replace(replaceHostname.replaceFromCustom, replaceHostname.replaceTo);
                }
            }
        }
        return d;
    }

    /**
     * Executed on SIP UA connection failure
     *
     * @param {SIP.Transport} t
     * @private
     */
    onFsDisconnected(t) {
        var SIP = require('sip.js');
        t = t.transport;
        if (t.ua.error === SIP.UA.C.NETWORK_ERROR) {
            // send this message like we got it as service message
            this.onFsServiceMessage({
                info: {
                    disconnected: true,
                    data: t
                }
            });
        }
    }

//////////////////////////////////////////////////
    /**
     * Open filemanager window for given folder
     *
     * @param {Object} f Folder
     * @private
     */
    openFmWindow(f) {
        // close any opened filemanager window
        var fm = CmpMgr.getByXtype(LiveFilemanagerWindow.prototype.xtype);
        if (fm) {
            fm.hide(true);
        }

        let win = new LiveFilemanagerWindow({
            enableParentFolder: false,
            enableFilter: false,
            enableRefresh: false,
            data: []
        });
        Connection.sendMessage(Constants.REQ_GET_FOLDER_FILES, {
            type : 'list',
            path : f.path
        }, win.onGetFolderFiles, win);
    }
//////////////

/////////////////////////////////////////////
    /**
     * Open survey window for given survey
     *
     * @param {Object} s Survey
     * @param {HTMLElement} b Button
     * @private
     */
    openSurveyWindow(s, b) {
        // close any opened survey window
        var sv = CmpMgr.getByXtype(LiveSurveyPreviewWindow.prototype.xtype);
        if (sv) {
            sv.hide(true);
        }

        // open preview window
        var preview = new LiveSurveyPreviewWindow({
            title: s.scripter,
            survey: s,
            onSuccess: () => {
                preview.hide(true);

                // remove preview button
                Element.removeNode(b);

                // show toast notification
                // Utils.dialog('', a24n('Survey submitted. Thank you.'));
            }
        });
    }
//////////////

    /**
     * Add new message to list
     *
     * @param {String} msg
     */
    addNewMessage(msg) {
        this.listEl.insertAdjacentHTML('beforeend', msg);
        this.messages.push(msg);

//////////////////////////////////////////////
        if (this.isBot) {
            var clientMsgs = this.listEl.querySelectorAll('.asseco-window-chat-client-message');
            if (clientMsgs.length && clientMsgs[clientMsgs.length - 1].nextSibling) {
                clientMsgs[clientMsgs.length - 1].nextSibling.scrollIntoView();
            } else {
                this.listEl.scrollTop = this.listEl.scrollHeight;
            }
        } else {
            this.listEl.scrollTop = this.listEl.scrollHeight;
        }
/////////////////
//////////////////////////////////////////
/////////////////////////////////////////////////////////
//////////////////

        if (this.audioEl) {
            this.audioEl.play();
        }

        this.onNewMessage();
    }

    /**
     * Send message via SIP UA client
     *
     * @param {String} body
     * @param {Object} meta
     * @param {String} from
     * @param {String} to
     * @private
     */
    sendFSMessage(body, meta, from = null, to = null) {
        if (Utils.isEmpty(to) && Utils.isEmpty(Asseco.fsUA.agentSipName)) {
            console.warn('LiveChatWindow::sendFSMessage - agent SIP name not defined');
            return;
        }

        let fsMsg = {
            sender     : from || Asseco.fsUA.clientSipName,
            recipients : to   || Asseco.fsUA.agentSipName
        };
        if (body) {
            fsMsg.body = body;
        }
        if (meta) {
            fsMsg.meta = meta;
        }

        console.log('LiveChatWindow::sendFSMessage: ', fsMsg);
        let sm = Asseco.fsUA.message(to || Asseco.fsUA.agentSipName, JSON.stringify(fsMsg));

        // add listeners for rejected i failed message
        if (body) {
            sm.on('rejected', this.onMessageSendFailed.createDelegate(this));
            sm.on('failed', this.onMessageSendFailed.createDelegate(this));
        }
    }

    /**
     * Executed on receiving new message
     *
     * @private
     */
    onNewMessage() {
        if (this.destroyed) {
            return;
        }

        // set unread message count
        if (
            this.hidden ||
            (this.drawer && ! Element.hasClass(this.getEl('.mdl-layout__drawer'), 'is-visible'))
        ) {
            this.unreadCount++;

            // show new message indicator if window is hidden
            if (this.hidden) {
                let cF = CmpMgr.getByXtype(this.__proto__.xtype.replace('Window', ''));
                if (cF) {
                    Element.addBadge(cF.containerEl, this.unreadCount, false, 'red');
                }
            }
            // show new message indicator if we have drawer and is collapsed
            else if (this.dBtn) {
                Element.addBadge(this.dBtn, this.unreadCount, true, 'red');
            }
        }
    }

    /**
     * Get transcript from chat
     */
    onDownloadTranscript() {
        var template = require('babel-loader!template-string-loader!./Download.html')({
            textFromChat: this.messages.join('\n'),
            title: this.group
        });

        Utils.download(new Blob([template], {type : 'text/html'}), a24n('Transcript') + '.html');
    }

    /**
     * Get upload key
     *
     * @private
     */
    getUploadKey() {
        if (Connection.getStatus() === Connection.OPEN) {
            // get upload key
            Connection.sendMessage(Constants.REQ_GET_UPLOAD_KEY, null, this.onGetUploadKey, this);
        }
        else {
            Element.addClass(this.progressEl, 'asseco-hidden');
        }
    }

    /**
     * Executed after upload key is fetched
     *
     * @param {Connection} conn Reference to web socket connection
     * @param {Object} msg Message received on web socket
     * @private
     */
    onGetUploadKey(conn, msg) {
        Element.removeClass(this.progressEl, 'asseco-hidden');

        var formdata = new FormData();
        formdata.append('uploadKey', msg.data);
        formdata.append('selectFile', this.selectFile.files[0]);

        var ajax = new XMLHttpRequest();
        ajax.upload.addEventListener('progress', this.onSendFileProgress.createDelegate(this));
        ajax.addEventListener('loadend', this.onSendFileComplete.createDelegate(this));
        ajax.open('POST',  Asseco.ChatServerUrl + '/server/chat-upload.php');
        ajax.send(formdata);
    }

    /**
     * Show file upload progress
     *
     * @param {Event} event
     * @private
     */
    onSendFileProgress(event) {
        if (event.total > 0) {
            this.progressEl.value = Math.round((event.loaded / event.total) * 100);
        }
    }

    /**
     * Called after upload file is completed (success or failure)
     *
     * @param {Event} event
     * @private
     */
    onSendFileComplete(event) {
        this.getEl('#asseco-chat-window-selectFile').value = '';
        this.progressEl.value = 0;
        Element.addClass(this.progressEl, 'asseco-hidden');

        if (event.target.status === 200 && ! Utils.isEmpty(event.target.responseText)) {
            // send message
            Connection.sendMessage(Constants.REQ_SEND_FILE, JSON.parse(event.target.responseText), this.onSendFile, this);
        }
        else {
            Utils.toast(a24n('File upload failed'));
        }

        Element.enabledElement('asseco-chat-window-uploadFile');
    }

    /**
     * Executed after file is sent
     *
     * @param {Connection} conn Reference to web socket connection
     * @param {Object} msg Message received on web socket
     * @private
     */
    onSendFile(conn, msg) {
        var d = JSON.parse(msg.data),
            time = Utils.getLocaleTime(),

            message = require('babel-loader!template-string-loader!./Client.html')({
                message : d.clientLink.trim(),
                time    : time
            });

        // send message via SIP client
        this.sendFSMessage(d.agentLink.trim());

        this.listEl.insertAdjacentHTML('beforeend', message);
        this.messages.push(message);

        // scroll to botto of the content
        this.listEl.scrollTop = this.listEl.scrollHeight;

        if (this.audioEl) {
            this.audioEl.play();
        }
    }

    /**
     * Replace placeholders in given message
     * 
     * @param {String} message 
     * @return {String}
     */
    replacePlaceholders(message) {
        message = message || '';

        message = message.replace('{addVideoIcon}', Utils.getIconMarkup(this.addVideoIcon, '', '', '#000'));
        message = message.replace('{addAudioIcon}', Utils.getIconMarkup(this.addAudioIcon, '', '', '#000'));
        message = message.replace('{callAgentIcon}', Utils.getIconMarkup(this.agentIcon, '', '', '#000'));

        return message;
    }

////////////////////////////////////////////////
    /**
     * Executed on add video button click
     */
    onAddVideo() {
        var LivePlans = require('widgets/plans/Plans').default,
            LiveVideoChatWindowFS = require('./../../videochat/window/WindowFS').default;

        // collect videochat global config if defined
        var vWinConf = {};
        if (Asseco.hasOwnProperty('config') && Asseco.config.hasOwnProperty('LiveVideoChat') && Asseco.config.LiveVideoChat.hasOwnProperty('winCfg')) {
            vWinConf = Asseco.config.LiveVideoChat.winCfg;
        }

        if (this.isBot) {
            this.botToAgent = true;
            if (typeof this.destroyPlansFn === 'function') {
                this.destroyPlansFn();
            }
            this.destroy();

            new LivePlans({
                chatWindowClass : LiveVideoChatWindowFS,
                mediaType       : Constants.MEDIA_TYPE_VIDEOCHAT,
                list            : 'videochat',
                autoNumber      : this.addVideoAutoNumber,
                winCfg          : vWinConf
            });

            return;
        }

        this.addingVideo = true;

        // show adding video indicator
        this.listEl.insertAdjacentHTML('beforeend',
            `<div class="asseco-chat-adding-video">
                ${Utils.getSpinner()}
                <div>${a24n('Waiting for video')}...</div>
            </div>`
        );
        this.listEl.scrollTop = this.listEl.scrollHeight;

        if (Asseco.fsUA) {
            // get current client sipName and chat agent which we will use for issuing videochat
            var chatSipName = Asseco.fsUA.clientSipName,
                reservedAgent = Asseco.fsUA.agentSipName;

            // send adding video signal to agent
            console.log('LiveChatWindow::Sending ADDINGVIDEO signal to agent');
            this.sendFSMessage(null, [{
                category : Constants.MSG_CAT_SIGNAL,
                name     : Constants.SIGNAL_ADDINGVIDEO
            }]);

            console.log('LiveChatWindow::Closing SIP UA');
            Asseco.fsUA.stop();
            Asseco.fsUA = null;

            console.log('LiveChatWindow::issuing videochat to: ' + this.addVideoAutoNumber);

            // issue new videochat but with plans window hidden
            new LivePlans({
                renderHidden    : true,
                chatWindowClass : LiveVideoChatWindowFS,
                mediaType       : Constants.MEDIA_TYPE_VIDEOCHAT,
                list            : 'videochat',
                autoNumber      : this.addVideoAutoNumber,
                reservedAgent   : reservedAgent,
                winCfg          : Utils.apply({
                    // transfer current messages and documents from old chat to new videochat
                    initMessage : this.messages,
                    documents   : this.documents,
                    style       : 'height: 550px',
                    onChatStart : () => {
                        console.log('LiveChatWindow::onAddVideo - closing old chat: ' + chatSipName);

                        // send disconnect signal to agent for old chat
                        this.sendFSMessage(null, [{
                            category : Constants.MSG_CAT_SIGNAL,
                            name     : Constants.SIGNAL_DISCONNECTED,
                            value    : Asseco.fsUA.clientSipName
                        }], chatSipName, reservedAgent);

                        // close chat window
                        this.hide(true);
                    }
                }, vWinConf)
            });
        }
    }
//////////////

////////////////////////////////////////////////
    /**
     * Executed on add audio button click
     * 
     * TODO: fix addAudio for chat with agent
     */
    onAddAudio() {
        var LivePlans = require('widgets/plans/Plans').default,
            LiveAudioChatWindowFS = require('./../../audiochat/window/WindowFS').default;

        // collect audiochat global config if defined
        var aWinConf = {};
        if (Asseco.hasOwnProperty('config') && Asseco.config.hasOwnProperty('LiveAudioChat') && Asseco.config.LiveAudioChat.hasOwnProperty('winCfg')) {
            aWinConf = Asseco.config.LiveAudioChat.winCfg;
        }

        if (this.isBot) {
            this.botToAgent = true;
            if (typeof this.destroyPlansFn === 'function') {
                this.destroyPlansFn();
            }
            this.destroy();

            new LivePlans({
                chatWindowClass : LiveAudioChatWindowFS,
                mediaType       : Constants.MEDIA_TYPE_VIDEOCHAT,
                list            : 'audiochat',
                autoNumber      : this.addAudioAutoNumber,
                winCfg          : aWinConf
            });
            
            return;
        }

        this.addingAudio = true;

        // show adding audio indicator
        this.listEl.insertAdjacentHTML('beforeend',
            `<div class="asseco-chat-adding-audio">
                ${Utils.getSpinner()}
                <div>${a24n('Waiting for audio')}...</div>
            </div>`
        );
        this.listEl.scrollTop = this.listEl.scrollHeight;

        if (Asseco.fsUA) {
            // get current client sipName and chat agent which we will use for issuing audiochat
            var chatSipName = Asseco.fsUA.clientSipName,
                reservedAgent = Asseco.fsUA.agentSipName;

            // send adding audio signal to agent
            console.log('LiveChatWindow::Sending ADDINGVIDEO signal to agent');
            this.sendFSMessage(null, [{
                category : Constants.MSG_CAT_SIGNAL,
                name     : Constants.SIGNAL_ADDINGVIDEO
            }]);

            console.log('LiveChatWindow::Closing SIP UA');
            Asseco.fsUA.stop();
            Asseco.fsUA = null;

            console.log('LiveChatWindow::issuing audiochat to: ' + this.addAudioAutoNumber);

            // issue new audio but with plans window hidden
            new LivePlans({
                renderHidden    : true,
                chatWindowClass : LiveAudioChatWindowFS,
                mediaType       : Constants.MEDIA_TYPE_VIDEOCHAT,
                list            : 'audiochat',
                autoNumber      : this.addAudioAutoNumber,
                reservedAgent   : reservedAgent,
                winCfg          : Utils.apply({
                    // transfer current messages and documents from old chat to new audiochat
                    initMessage : this.messages,
                    documents   : this.documents,
                    style       : 'height: 550px',
                    onChatStart : () => {
                        console.log('LiveChatWindow::onAddAudio - closing old chat: ' + chatSipName);

                        // send disconnect signal to agent for old chat
                        this.sendFSMessage(null, [{
                            category : Constants.MSG_CAT_SIGNAL,
                            name     : Constants.SIGNAL_DISCONNECTED,
                            value    : Asseco.fsUA.clientSipName
                        }], chatSipName, reservedAgent);

                        // close chat window
                        this.hide(true);
                    }
                }, aWinConf)
            });
        }
    }
//////////////

//////////////////////////////////////////
    /**
     * Register to bot
     *
     * @private
     */
    botRegister() {
        console.log('LiveChatWindow::Bot register...');
        Connection.sendMessage(Constants.REQ_BOT_REGISTER, {}, this.onBotRegister, this);
    }

    /**
     * Executed after bot is registred
     *
     * @param {Connection} conn Reference to web socket connection
     * @param {Object} msg Message received on web socket
     * @private
     */
    onBotRegister(conn, msg) {
        this.renderBotMessages(msg.data);
        this.attachBotListeners();
    }

    /**
     * Send message to bot
     *
     * @param {String} msg
     * @private
     */
    sendBotMessage(msg) {
        Connection.sendMessage(Constants.REQ_BOT_SEND_MESSAGE, {
            text: msg
        }, this.onSendBotMessage, this);
    }

    /**
     * Executed after sending message and getting response from server
     *
     * @param {Connection} conn Reference to web socket connection
     * @param {Object} msg Message received on web socket
     * @private
     */
    onSendBotMessage(conn, msg) {
        this.renderBotMessages(msg.data);
        this.attachBotListeners();
    }

    /**
     * Render bot messages
     *
     * @type {Array} msgs
     * @private
     */
    renderBotMessages(msgs) {
        var d = JSON.parse(msgs);
        if (d.success && Array.isArray(d.data)) {
            d.data.forEach((m) => {
                let t = new Date(m.timeCreated).toLocaleTimeString(Asseco.Localization.getLang(), {hour: 'numeric', minute: 'numeric'});

                if (m.sender === 'Bot')  {
                    var message = require('autolinker').link(m.text, {stripPrefix: false});
                    message = this.replacePlaceholders(message);

                    this.addNewMessage(require('babel-loader!template-string-loader!./Agent.html')({
                        agentIcon : Utils.getIconMarkup(this.agentIcon, '', '', '#000'),
                        message   : message,
                        time      : t
                    }));

                    if (m.lastMessage === true) {
                        this.ended = true;

                        var textArea = this.inputEl.querySelector('textarea');
                        if (textArea) {
                            textArea.disabled = true;
                        }
                        var sendButton = this.getEl('.asseco-chat-window-send button');
                        if (sendButton) {
                            sendButton.disabled = true;
                        }
                    }
                }
                else if (m.sender === 'User') {
                    this.addNewMessage(require('babel-loader!template-string-loader!./Client.html')({
                        message   : m.text,
                        time      : t
                    }));
                }
            });
        } else {
            this.addNewMessage(require('babel-loader!template-string-loader!./Error.html')({
                message: a24n('There has been an error. Please refresh page or talk with agent.')
            }));

            /**
             * Disable typing into textarea and clicking send button
             */
            var textArea = this.inputEl.querySelector('textarea');
            if (textArea) {
                textArea.disabled = true;
            }
            var sendButton = this.getEl('.asseco-chat-window-send button');
            if (sendButton) {
                sendButton.disabled = true;
            }
        }
    }

    /**
     * Add onclick event listener to buttons if not already set
     *
     * @private
     */
    attachBotListeners() {
        Array.prototype.slice.call(this.containerEl.querySelectorAll('.predefined-answers')).forEach(b => {
            this.cHU(b);
            b.onclick = (e) => {
                if (this.ended) {
                    return;
                }

                // To have support for both <button> and <input> tags
                this.onMessageSend(e.target, (e.target.value || e.target.textContent).trim());
            };
        }, this);
    }
//////////////
}
LiveChatWindowFS.prototype.xtype = 'LiveChatWindow';
export default LiveChatWindowFS;
